import type { IconProps } from './types';

export function Cardigan({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M76 64 Q88 60 100 64 Q112 76 124 88 L132 88 Q144 76 156 64 Q168 60 180 64 Q204 76 224 100 L224 208 Q224 216 216 216 L204 216 Q196 216 196 208 L196 100 Q188 96 180 92 L180 208 Q180 216 172 216 L84 216 Q76 216 76 208 L76 92 Q68 96 60 100 L60 208 Q60 216 52 216 L40 216 Q32 216 32 208 L32 100 Q52 76 76 64 Z" />
      <path d="M128 92 Q128 152 128 216" />
    </svg>
  );
}
